import React, { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams, useNavigate, useLocation } from "react-router-dom";

import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { motion } from "framer-motion";

import PageHeader from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import CommentCard from "components/other-cards/CommentCard"
import { SectionHeading } from "components/misc/Headings";
import { Toast } from 'primereact/toast';
import { AiFillLike, AiFillEye } from 'react-icons/ai';
import { FaComment, FaPenSquare, FaShare, FaCopy, FaFacebook, FaLinkedin, FaWhatsapp, FaTwitter, FaTimes } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



const PostTextContainer = tw.div``;
const PostsContainer = tw.div`mt-12 flex flex-row sm:flex-row sm:justify-between lg:justify-start w-full`;
const Post = tw(motion.div)`block sm:max-w-sm cursor-pointer mb-16 last:mb-0 sm:mb-0 sm:odd:mr-8 lg:mr-8 xl:mr-16 w-full`;
const Title = tw.h5`mt-6 text-xl font-bold transition duration-300 group-hover:text-[#0049AC]`;
const Description = tw.p`mt-2 font-medium text-secondary-100 leading-loose text-sm`;
const AuthorInfo = tw.div`mt-6 flex items-center`;
const AuthorImage = tw.img`w-12 h-12 rounded-full`;
const AuthorNameAndProfession = tw.div`ml-4`;
const AuthorName = tw.h6`font-semibold text-lg`;
const AuthorProfile = tw.p`text-secondary-100 text-sm`;

const Image = styled(motion.div)((props) => [
  `background-image: url("${props.$imageSrc}");`,
  tw`h-64 bg-cover bg-center rounded`,
]);

const RecentPostsContainer = styled.div`
  ${tw`mt-0 lg:w-2/3`}
  ${PostsContainer} {
    ${tw`flex flex-wrap lg:flex-col`}
  }
  ${Post} {
    ${tw`flex justify-between mb-10 max-w-none w-full sm:w-1/2 lg:w-auto sm:odd:pr-12 lg:odd:pr-0 mr-0`}
  }
  ${Title} {
    ${tw`text-base text-lg mt-0 mr-4 lg:text-2xl`}
  }
  ${AuthorName} {
    ${tw`mt-3 text-sm text-secondary-100 font-normal leading-none`}
  }
  ${Image} {
    ${tw`h-20 w-20 flex-shrink-0`}
  }
`;

const HeadingRow = tw.div`flex justify-between items-center`;
const Heading = tw(SectionHeading)`text-2xl lg:text-4xl`;
const HeadingSuggest = tw(SectionHeading)`text-left lg:text-2xl text-lg`;
const Stats = tw.div`flex justify-between lg:space-x-8 lg:ml-0 ml-20 lg:mt-2 mr-2 lg:text-lg text-xs text-gray-600 `;
const StatItem = tw.div`flex items-center text-sm mr-1 ml-2 py-2`;
const CardContainer = tw.div`lg:flex justify-between relative lg:mr-4 mt-4 lg:h-24 h-32 bg-gray-200 rounded shadow w-full`;
const ProfileSection = tw.div`flex justify-start lg:ml-4 ml-0 space-x-2 lg:text-lg text-sm lg:mt-4 mt-2 lg:py-0 py-2`;
const ProfileImage = tw.img`w-16 h-16 rounded-full border border-gray-300 ml-4`;
const UserInfo = tw.div`flex flex-col lg:mt-0 mt-1`;
const UserName = tw.h4`lg:text-lg text-sm font-semibold`;
const UserDesignation = tw.span`text-gray-600 lg:text-sm text-xs`;
const PostContent = tw.div`mt-8`;


const CreationDate = tw.div`text-gray-600 font-semibold lg:text-sm text-xs`;

const DialogBox = styled.div`
  ${tw`fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-500 bg-opacity-50 z-50`}
  display: ${({ show }) => (show ? "flex" : "none")};
  animation: fadeIn 0.3s ease-in-out;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const DialogContent = tw.div`bg-white p-6 rounded-lg shadow-xl text-center w-[90%] max-w-md relative`;
const DialogHeading = tw.h2`text-xl font-bold text-gray-900`;

const CloseButton = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      border: "none",
      fontSize: "30px",
      cursor: "pointer",
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "transparent",
      color: "#333",
    }}
    aria-label="Close"
  >
    &times;
  </button>
);

export default () => {

  const navigate = useNavigate();
  const { blogId } = useParams(); // Extract the blogId from the route
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const ipAddress = useRef("");

  const url = window.location.origin + location.pathname + location.search;

  const [blogContent, setBlogContent] = useState("");
  const [blogTitle, setBlogTitle] = useState(params.get("blogTitle"));
  const [stats, setStats] = useState({ comments: 0, views: 0, likes: 0, shares: 0 });
  // const [comments, setComments] = useState([]);
  const [lastUpdate, setLastUpdate] = useState('');
  const [suggestedBlogs, setSuggestedBlogs] = useState([]);
  // const [commentInput, setCommentInput] = useState("");
  // const [userDetails, setUserDetails] = useState(JSON.parse(localStorage.getItem("userDetails")) || null);
  const [blogAuthor, setBlogAuthor] = useState({ name: "", profileImage: "", designation: "" });
  const hasTriggered = useRef(false); // Ensure the event triggers only once
  const [liked, setLiked] = useState(false)
  const [isComment, setIsComment] = useState(false)
  const [showDialog, setShowDialog] = useState(false)

  const toast = useRef(null);

  const showInfo = (summary, detail) => {
    toast.current.show({ severity: 'success', summary: summary, detail: detail, life: 3000 });
  }

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  useEffect(() => {

    const params = new URLSearchParams(location.search);
    setBlogTitle(params.get("blogTitle"))

    const fetchBlogData = async () => {
      try {

        const response = await fetch(`${API_URL}/web/blogs/fetch-blog?blogId=${blogId}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          const blogData = result.data[0];
          setBlogContent(blogData.blog_content);
          setLastUpdate(blogData.updated_at);
          setLiked(blogData.blog_liked);
          setStats({ comments: blogData.blog_comments, views: blogData.blog_views, likes: blogData.blog_likes, shares: blogData.blog_shares });
          setBlogAuthor({
            name: blogData.author_name,
            profileImage: blogData.author_pic,
            designation: blogData.author_designation,
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchBlogData();

    const fetchSuggestedData = async () => {
      try {

        const response = await fetch(`${API_URL}/web/blogs/suggested-blogs?blogId=${blogId}&title=${blogTitle}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          const suggestData = result.data;
          setSuggestedBlogs(suggestData)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };



    fetchSuggestedData();

    window.addEventListener("scroll", handleScrollView);

    return () => {
      window.removeEventListener("scroll", handleScrollView);
    };

  }, [blogId, location.search]);

  const handleScrollView = async () => {
    if (hasTriggered.current) return; // Prevent multiple triggers

    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    const scrolledPercentage = (scrollTop + clientHeight) / scrollHeight;

    if (scrolledPercentage > 0.7) {
      hasTriggered.current = true; // Mark as triggered
      sendViewUpdate();
    }
  }

  const sendViewUpdate = async () => {
    try {

      const requestBody = {
        blogId: blogId,
        userIp: ipAddress.current,
        actionType: "view",
      };

      const response = await fetch(`${API_URL}/web/blogs/add-view`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (result.header.resCode === 200 && result.data.length > 0) {
        setStats(prev => ({ ...prev, views: +prev.views + 1 }));
        // setStats(prev => ({ ...prev, views: (+(stats.views) + 1) }));
      }
    } catch (error) {
      console.error("Error updating view:", error);
    }
  };

  const formatNumber = (views) => {
    if (views >= 1000000000) {
      return (views / 1000000000).toFixed(1) + "B"; // Billions
    } else if (views >= 1000000) {
      return (views / 1000000).toFixed(1) + "M"; // Millions
    } else if (views >= 1000) {
      return (views / 1000).toFixed(1) + "K"; // Thousands
    } else {
      return views.toString(); // Less than 1,000
    }
  };

  const handleLike = async () => {

    try {
      const requestBody = {
        blogId: blogId,
        userIp: ipAddress.current,
        actionType: "like"
      };

      const response = await fetch(`${API_URL}/web/blogs/update-like`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (result.header.resCode === 200) {
        if (result.data.length > 0) {
          setLiked(true)
          setStats(prev => ({ ...prev, likes: +prev.likes + 1 }));
          // setStats(prev => ({ ...prev, likes: (+(stats.likes) + 1) }));
        } else {
          setLiked(false)
          setStats(prev => ({ ...prev, likes: +prev.likes -1 }));
          // setStats(prev => ({ ...prev, likes: (+(stats.likes) - 1) }));
        }
      }

    } catch (error) {
      console.error("Error updating like:", error);
    }
  };

  const updateShareCount = async () => {

    try {
      const requestBody = {
        blogId: blogId,
        userIp: ipAddress.current,
        actionType: "share"
      };

      const response = await fetch(`${API_URL}/web/blogs/add-share`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (result.header.resCode === 200 && result.data.length > 0) {
        setStats(prev => ({ ...prev, shares: +prev.shares + 1 }));
        // setStats(prev => ({ ...prev, shares: (+(stats.shares) + 1) }));
      }
    } catch (error) {
      console.error("Error updating shares:", error);
    }
  };

  const handleWriteBlogClick = () => {
    navigate("/pg/blogs/write");
  };

  const handleCommentClick = () => {
    navigate("/pg/blogs/write");
  };

  const handleShareClick = async () => {
    setShowDialog(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      showInfo('Link Copied !', 'Blog Link is Copied to clipboard');
      updateShareCount();
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  const handleSocialShare = (platform) => {
    let shareUrl = "";
    if (platform === "facebook") {
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    } else if (platform === "twitter") {
      shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
    } else if (platform === "linkedin") {
      shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    } else if (platform === "whatsapp") {
      shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
    }

    showInfo('Blog Shared !', 'Blog shared to ' + platform);
    window.open(shareUrl, "_blank", "noopener,noreferrer");
    updateShareCount();
  };

  const handleClose = () => {
    document.body.style.overflow = 'auto';
    setShowDialog(false)
  };

  // const handleCommentSubmit = e => {
  //   e.preventDefault();
  //   const commentData = {
  //     content: commentInput,
  //     userDetails: userDetails || { name: e.target.name.value, email: e.target.email.value },
  //   };

  //   fetch(`/api/blog/${blogId}/comment`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(commentData),
  //   })
  //     .then(res => res.json())
  //     .then(data => {
  //       setComments(prev => [...prev, data]);
  //       setCommentInput("");
  //     });
  // };

  const mockComments = [
    {
      id: 1,
      userDetails: { name: "John Doe" },
      content: "This is a great blog post!",
      replies: [
        {
          id: 101,
          userDetails: { name: "Jane Doe" },
          content: "I agree, it was very informative.",
        },
      ],
    },
    {
      id: 2,
      userDetails: { name: "Alice" },
      content: "Thanks for sharing!",
      replies: [],
    },
  ];


  return (
    <AnimationRevealPage>
      <PageHeader pageName="Blogs" titleName="Read Blog" />
      <Toast ref={toast} />
      <Container>
        <br />
        <HeadingRow>
          <Heading>{blogTitle}</Heading>
        </HeadingRow>
        {blogContent.length > 0 ?
          <CardContainer>
            <ProfileSection>
              <ProfileImage src={blogAuthor.profileImage || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"} alt="Profile" />
              <UserInfo>
                <UserName>{blogAuthor.name || "Author Name"}</UserName>
                <UserDesignation>{blogAuthor.designation || "Designation"}</UserDesignation>
                <CreationDate>Last Updated : {new Date(lastUpdate).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }).replace(',', ' @')}</CreationDate>
              </UserInfo>
            </ProfileSection>
            <Stats className="flex flex-wrap justify-between gap-2 sm:gap-4 md:gap-6 w-full">
              <StatItem className="flex items-center"><AiFillEye size={25} className="icon-spacing" />{formatNumber(stats.views)}</StatItem>
              <StatItem className="flex items-center">{liked ? <AiFillLike size={25} className="icon-spacing color-like" onClick={handleLike} /> : <AiFillLike size={25} className="icon-spacing" onClick={handleLike} />}{formatNumber(stats.likes)}</StatItem>
              <StatItem className="flex items-center"><FaComment size={25} className="icon-spacing" onClick={handleCommentClick} />{formatNumber(stats.comments)}</StatItem>
              <StatItem className="flex items-center"><FaShare size={25} className="icon-spacing" onClick={handleShareClick} />{formatNumber(stats.shares)}</StatItem>
              {/* <StatItem className="flex items-center"><FaPenSquare size={25} className="icon-spacing" onClick={handleWriteBlogClick} /></StatItem> */}
            </Stats>
          </CardContainer>
          : <div><br /><br /> <h2>Loading blog content...</h2></div>
        }

        <DialogBox show={showDialog}>
          <DialogContent>
            <CloseButton onClick={handleClose} />
            <DialogHeading className="dialog-heading">Share this blog with your friends.</DialogHeading>
            <br />
            <Stats className="flex justify-between w-36">
              <StatItem><FaCopy size={25} className="icon-spacing" onClick={() => handleCopyLink()} /></StatItem>
              <StatItem><FaFacebook color="#4267B2" size={25} className="icon-spacing" onClick={() => handleSocialShare("facebook")} /></StatItem>
              <StatItem><FaTwitter color="#1DA1F2" size={25} className="icon-spacing" onClick={() => handleSocialShare("twitter")} /></StatItem>
              <StatItem><FaLinkedin color="#0077b5" size={25} className="icon-spacing" onClick={() => handleSocialShare("linkedin")} /></StatItem>
              <StatItem><FaWhatsapp color="#25D366" size={25} className="icon-spacing" onClick={() => handleSocialShare("whatsapp")} /></StatItem>
            </Stats>
          </DialogContent>
        </DialogBox>

        <PostContent dangerouslySetInnerHTML={{ __html: blogContent }} />
        <br />
        <CommentCard comments={mockComments} commentsEnabled={isComment} />
        <br /><br />
        <RecentPostsContainer>
          {suggestedBlogs.length > 0 && <HeadingSuggest>You may also like</HeadingSuggest>}
          <PostsContainer>
            {suggestedBlogs.map((post) => (
              <Post
                key={post.id}
                className="group"
                onClick={() => navigate(`/pg/blogs/${post.id}/read?blogTitle=${post.title}`)}
              >
                <PostTextContainer>
                  <Title>{post.title}</Title>
                  <AuthorName>{post.name}</AuthorName>
                </PostTextContainer>
                <Image $imageSrc={post.thumbnail_url} />
              </Post>
            ))}
          </PostsContainer>
        </RecentPostsContainer>
      </Container>
      <FooterCard />
    </AnimationRevealPage>
  );
};
